/**
 * useAccesoEstado — estado del candado de acceso (GET /api/acceso/estado), cada 60 s.
 * Alimenta el aviso previo (cuenta regresiva), la barra de modo prueba y «Ver como».
 * El reloj se corrige con `ahora` del servidor: la cuenta regresiva no depende del reloj de la PC.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client.js";
import { useAuth } from "../context/AuthContext.jsx";

export function useAccesoEstado() {
  const { miembro } = useAuth();
  const [estado, setEstado] = useState(null);

  useEffect(() => {
    if (!miembro) return;
    let vivo = true;
    const cargar = async () => {
      try {
        const r = await api.getAccesoEstado();
        if (!vivo || !r) return;
        const desfase = r.ahora ? new Date(r.ahora).getTime() - Date.now() : 0;
        setEstado({ ...r, desfase });
      } catch { /* sin estado: no se muestra nada */ }
    };
    cargar();
    const t = setInterval(cargar, 60_000);
    return () => { vivo = false; clearInterval(t); };
  }, [miembro?.id]);

  return estado;
}

/** Barra por rol que se está «viendo como» (solo para los habilitados en modo prueba). */
export const VER_COMO_KEY = "crew_ver_como";
export function leerVerComo() {
  try { return localStorage.getItem(VER_COMO_KEY) || null; } catch { return null; }
}
